import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AwardsGallery.css";

const AwardsGallery = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const awardGallery = [
    {
      src: "/awardsandrecognization/qfftEscreenshot20240902194711.png",
      cap: 'Robokalam receiving "Tech For Good" award at T-Hub',
    },
    {
      src: "/awardsandrecognization/CEJOkscreenshot20240902194751.png",
      cap: "Support for Robothon by Ministry of Education, TS",
    },
    {
      src: "/awardsandrecognization/OBOLjscreenshot20240902194609.png",
      cap: "Runner-up for IoT solutions",
    },
  ];

  return (
    <section className="awards-gallery-section">
      <h2 className="awards-heading" data-aos="fade-right">
        Awards
      </h2>

      <div className="awards-row-container" data-aos="fade-up">
        <div className="awards-gallery">
          {awardGallery.map(({ src, cap }, i) => (
            <figure
              key={i}
              className="award-card"
              data-aos="fade-up"
              data-aos-delay={i * 200}
            >
              <img src={src} alt={cap} />
              <figcaption>{cap}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsGallery;
